import { Reveal } from "@/components/Reveal";
import { Tape } from "@/components/Notebook";
import { useLang } from "@/i18n";

/**
 * Section 2 — Short client proof (High-Stakes landing page only).
 * Static proof block: Marilena Katsimi. No logos, no carousel, no video
 * embed here — the video lives later, in Section 6 (client story + video).
 */
export const ClientProof = () => {
  const { t } = useLang();
  return (
    <section
      className="relative z-10 py-14 md:py-16 border-y border-ink/10 bg-paper-deep/40"
      data-testid="client-proof-section"
    >
      <div className="max-w-[1100px] mx-auto px-5 md:px-10">
        <Reveal>
          <div className="relative bg-paper border border-ink/12 shadow-[4px_8px_30px_rgba(18,20,24,0.08)] px-6 md:px-10 py-8 md:py-10 grid md:grid-cols-12 gap-6 md:gap-10 items-center">
            <Tape className="absolute -top-4 left-10 hidden md:block" rotate={-5} width={110} />

            <div className="md:col-span-3">
              <p className="font-body text-xs uppercase tracking-[0.24em] text-terracotta mb-2" data-testid="client-proof-eyebrow">
                {t("landing.proof_eyebrow")}
              </p>
              <p className="font-body font-medium text-ink" data-testid="client-proof-name">
                {t("landing.proof_name")}
              </p>
              <p className="font-body text-sm text-ink-soft" data-testid="client-proof-role">
                {t("landing.proof_role")}
              </p>
            </div>

            <div className="md:col-span-9">
              <h2 className="font-serif text-xl md:text-2xl text-ink leading-snug mb-2" data-testid="client-proof-title">
                {t("landing.proof_title")}
              </h2>
              <p className="font-body text-sm md:text-base text-ink-soft leading-relaxed" data-testid="client-proof-description">
                {t("landing.proof_description")}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
